import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Success from "@/pages/Success";
import Admin from "@/pages/Admin";
import Rebook from "@/pages/Rebook";
import Reflect from "@/pages/Reflect";
import SacredReset from "@/pages/SacredReset";
import SacredResetWatch from "@/pages/SacredResetWatch";
import About from "@/pages/About";
import Community from "@/pages/Community";
import Reclaim from "@/pages/Reclaim";
import Become from "@/pages/Become";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

// Auto-scroll to the top of the page on every route change (unless there's a hash target).
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) return; // let in-page anchors work
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Nav />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/success" element={<Success />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/rebook/:token" element={<Rebook />} />
          <Route path="/reflect/:token" element={<Reflect />} />
          <Route path="/sacred-reset" element={<SacredReset />} />
          <Route path="/sacred-reset/watch" element={<SacredResetWatch />} />
          {/* Aliases: same components, new brand naming */}
          <Route path="/pause-the-spiral" element={<SacredReset />} />
          <Route path="/pause-the-spiral/watch" element={<SacredResetWatch />} />
          <Route path="/about" element={<About />} />
          <Route path="/community" element={<Community />} />
          <Route path="/reclaim" element={<Reclaim />} />
          <Route path="/become" element={<Become />} />
        </Routes>
        <Footer />
        <Toaster
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#4F5D4F",
              color: "#F6F1EA",
              border: "1px solid #B89B63",
              borderRadius: 0,
              fontFamily: "Outfit, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
